import "core-js/modules/es6.regexp.search";
//
//
//
//
//
//
//
//
//
//
import PageLayout from "../page/PageLayout";
import RouteView from "./RouteView";
export default {
  name: "PageContent",
  components: {
    RouteView: RouteView,
    PageLayout: PageLayout
  },
  data: function data() {
    return {
      title: '',
      description: '',
      linkList: [],
      extraImage: '',
      search: false,
      tabs: {}
    };
  },
  mounted: function mounted() {
    this.getPageHeaderInfo();
  },
  updated: function updated() {
    this.getPageHeaderInfo();
  },
  computed: {
    getTitle: function getTitle() {
      return this.$route.meta.title;
    }
  },
  methods: {
    getPageHeaderInfo: function getPageHeaderInfo() {
      // eslint-disable-next-line
      this.title = this.$route.meta.title; // 因为套用了一层 route-view 所以要取 ref 对象下的子节点的第一个对象

      var content = this.$refs.content && this.$refs.content.$children[0];

      if (content) {
        this.description = content.description;
        this.linkList = content.linkList;
        this.extraImage = content.extraImage;
        this.search = content.search == true ? true : false;
        this.tabs = content.tabs;
      }
    }
  }
};